// MARK://dhk8/pos/features/billing/sat-catalogs
// Minimal SAT catalog subsets used by the "facturar" flow (CFDI 4.0). These are
// the high-frequency options for a restaurant/POS receiver; the real, full
// catalogs come from the fiscal provider chain (DocketHub → Omnifiscal →
// FiscalAPI → SAT) when that lands. NOT exhaustive on purpose — keep the UI sane.

export interface SatOption {
  code: string
  label: string
}

/** c_UsoCFDI — most-used values for a B2C/B2B ticket. */
export const USO_CFDI_OPTIONS: readonly SatOption[] = [
  { code: 'G01', label: 'G01 — Adquisición de mercancías' },
  { code: 'G03', label: 'G03 — Gastos en general' },
  { code: 'P01', label: 'P01 — Por definir' },
  { code: 'S01', label: 'S01 — Sin efectos fiscales' },
  { code: 'D01', label: 'D01 — Honorarios médicos, dentales y gastos hospitalarios' },
  { code: 'I01', label: 'I01 — Construcciones' },
]

/** c_RegimenFiscal — the regimes a typical receiver picks. */
export const REGIMEN_FISCAL_OPTIONS: readonly SatOption[] = [
  { code: '601', label: '601 — General de Ley Personas Morales' },
  { code: '605', label: '605 — Sueldos y salarios e ingresos asimilados' },
  { code: '612', label: '612 — Personas Físicas con actividades empresariales y profesionales' },
  { code: '616', label: '616 — Sin obligaciones fiscales' },
  { code: '621', label: '621 — Incorporación Fiscal' },
  { code: '626', label: '626 — Régimen Simplificado de Confianza (RESICO)' },
]

/** c_FormaPago — payment forms the cashier may select. */
export const FORMA_PAGO_OPTIONS: readonly SatOption[] = [
  { code: '01', label: '01 — Efectivo' },
  { code: '03', label: '03 — Transferencia electrónica de fondos' },
  { code: '04', label: '04 — Tarjeta de crédito' },
  { code: '28', label: '28 — Tarjeta de débito' },
  { code: '99', label: '99 — Por definir' },
]

const RFC_RE = /^([A-ZÑ&]{3,4})\d{6}([A-Z\d]{3})$/

/** Loose CFDI-4.0 RFC syntactic check (12 = moral, 13 = física). Not a SAT lookup. */
export function isValidRfc(rfc: string): boolean {
  const v = rfc.trim().toUpperCase()
  return (v.length === 12 || v.length === 13) && RFC_RE.test(v)
}

export function labelForUso(code: string): string {
  return USO_CFDI_OPTIONS.find((o) => o.code === code)?.label ?? code
}
export function labelForRegimen(code: string): string {
  return REGIMEN_FISCAL_OPTIONS.find((o) => o.code === code)?.label ?? code
}
